export const ActionTypes = {
  OPEN_PUSHER_CONNECTION: 'PUSHER/OPEN-CONNECTION',
  RUN_PROOFREAD_CHECKS: 'CHECK/RUN_CHECKS',
  SET_FEEDBACKS: 'PARAPHRASER/SET_FEEDBACKS',
  APPEND_TO_FEEDBACKS: 'PARAPHRASER/APPEND_TO_FEEDBACKS',
  SET_PARAPHRASE_FLAG: 'PARAPHRASER/SET_PARAPHRASE_FLAG',
  SET_SENTENCE_OFFSETS: 'PARAPHRASER/SET_SENTENCE_OFFSETS',
  ADJUST_SENTENCE_OFFSETS: 'PARAPHRASER/ADJUST_SENTENCE_OFFSETS',
  SET_ACTIVE_FEEDBACK_TAB: 'PARAPHRASER/SET_ACTIVE_FEEDBACK_TAB',
  SET_IS_PAPER_CHECK_IN_PROGRESS: 'PARAPHRASER/SET_IS_PAPER_CHECK_IN_PROGRESS',
  SET_REWRITE_PANEL_SENTENCES: 'PARAPHRASER/SET_REWRITE_PANEL_SENTENCES',
  SET_ACTIVE_FEEDBACK_CARD_ID: 'PARAPHRASER/SET_ACTIVE_FEEDBACK_CARD_ID',
  SET_IS_TIMED_OUT: 'PARAPHRASER/SET_IS_TIMED_OUT',
  DELETE_FEEDBACK: 'PARAPHRASER/DELETE_FEEDBACK',
  UPDATE_TOTAL_FEEDBACK_COUNT: 'PARAPHRASER/UPDATE_TOTAL_FEEDBACK_COUNT',
  SET_TOTAL_FEEDBACK_COUNT: 'PARAPHRASER/SET_TOTAL_FEEDBACK_COUNT',
  SET_PAPER_ID: 'PARAPHRASER/SET_PAPER_ID',
  SET_PAPER_TITLE: 'PARAPHRASER/SET_PAPER_TITLE',
  SET_PAPER_REQUIRES_RECHECK: 'PARAPHRASER/SET_PAPER_REQUIRES_RECHECK',
  UPDATE_PAPER_HANDLER: 'PARAPHRASER/UPDATE_PAPER_HANDLER',
  SET_WORD_COUNT: 'PARAPHRASER/SET_WORD_COUNT',
  SET_FETCH_NEW_SENTENCES_LOADING: 'PARAPHRASER/SET_FETCH_NEW_SENTENCES_LOADING',
  SET_FETCH_SENTENCE_ERROR: 'PARAPHRASER/SET_FETCH_SENTENCE_ERROR',
} as const
